import {
  setLotSizeValue,
  wantAdBudgetValue,
  wantAdSqftValue,
} from "../../../helpers/createWantAd";
import {
  getUserId,
  getUserType,
  capitalizeFirstString,
} from "../../../helpers/common";
import { shareLocationPhrase } from "../../../helpers/shareLocation";
import { USER_TYPE_AGENT } from "../../../constants/common";
import {
  getPropertyArticle,
  getPropertyTextShare,
} from "../../../helpers/v2/shareWantad";
import { useSelector } from "react-redux";
import ProBadge from "../ProBadge";
import { isPremiumAgentPlan } from "../../../helpers/agentPlan";
import Logo from "../Logo";

// Card preview for share want ad
const ShareCardPreview = ({ adDetails, isSideCard = false, posterPlan }) => {
  const WantCreatedUserId = _.get(adDetails, "userId", false);
  const loggedInUserId = getUserId();
  const isOwnWantAd = WantCreatedUserId === loggedInUserId;
  const viewerPlan = useSelector(
    (state) => state.userProfile.userDetails?.[0]?.PlanName,
  );
  const isAgentCreated = _.get(adDetails, "isAgentCreated", "") == 1;
  const adType = _.get(adDetails, "adType", "");
  const adTypeText = adType === "BUY" ? "BUY" : "RENT";
  const propertyType = getPropertyTextShare(adDetails);
  const prprtyType = _.get(adDetails, "prprtyType", []);
  const clientName = _.get(adDetails, "clientName", []);
  const article = getPropertyArticle(propertyType);
  let bdgt = wantAdBudgetValue(
    _.get(adDetails, "minBdgt", ""),
    _.get(adDetails, "maxBdgt", ""),
  );
  let sqFt = wantAdSqftValue(
    _.get(adDetails, "sqFtMin", ""),
    _.get(adDetails, "sqFtMax", ""),
  );

  let ltSize = setLotSizeValue(
    _.get(adDetails, "minLtSz", null),
    _.get(adDetails, "maxLtSz", null),
  );
  let noBedRoom = _.get(adDetails, "noBedRm", null);
  let noBathRoom = _.get(adDetails, "noBathRm", null);

  const roomLabel = (rooms) =>
    rooms && rooms !== "Any" && Number(rooms) < 6 ? rooms + "+" : "Any";
  noBathRoom = roomLabel(noBathRoom);
  noBedRoom = roomLabel(noBedRoom);
  const userType = getUserType();
  const isAgent = userType === USER_TYPE_AGENT ? true : false;
  const shareLocation = shareLocationPhrase(adDetails);
  const posterIsPremium = posterPlan
    ? isPremiumAgentPlan(posterPlan)
    : adDetails?.isAgentPremium != null
      ? Boolean(Number(adDetails.isAgentPremium))
      : adDetails?.userPlan
        ? isPremiumAgentPlan(adDetails.userPlan)
        : isOwnWantAd && isPremiumAgentPlan(viewerPlan);
  const showAgentBlock = isOwnWantAd && isAgentCreated;

  const agentBlock = (
    <div
      className={`small-card-agent-card ${
        !adDetails?.userAvatar ? "small-card-no-image" : ""
      }`}
    >
      {adDetails?.userAvatar && (
        <img
          src={adDetails?.userAvatar}
          alt="Agent Avatar"
          className="small-card-agent-avatar"
        />
      )}
      <div className="small-card-agent-info">
        <div className="small-card-agent-name">
          {adDetails?.userFirstName} {adDetails?.userLastName}{" "}
          <ProBadge
            isAgentPremium={posterIsPremium}
            className="small-card-pro-label"
          />
        </div>
        <div className="small-card-agent-detail">
          Agent @ {adDetails?.userCompany}
        </div>
        <div className="small-card-agent-detail">{adDetails?.userPhone}</div>
      </div>
    </div>
  );

  return (
    <div
      className={`share-yourad-map-preview ${
        isSideCard ? "sidecard-preview" : ""
      }`}
    >
      <div className="share-yourad-map-preview-background-image" />
      <div className="share-yourad-map-preview-overlay" />
      <div className="share-yourad-map-preview-content">
        {isAgent ? (
          <>
            {/* Mirrors the image the API posts (socialShareWantad: isAgent && isSelf
                picks the "I HAVE A NEW ... NEED" template), so the preview an agent
                sees on their own listing is the card that actually gets shared. */}
            {isOwnWantAd ? (
              <>
                <p className="share-yourad-map-preview-subtitle">
                  I HAVE A NEW
                </p>
                <h1
                  className={`share-yourad-map-preview-title ${isSideCard ? "f-size-24 " : ""}`}
                >
                  {adTypeText}ER NEED
                </h1>
                <p className="share-yourad-map-preview-location">
                  Looking {shareLocation}
                </p>
              </>
            ) : (
              <>
                <h1
                  className={`share-yourad-map-preview-title ${isSideCard ? "f-size-24 " : ""}`}
                >
                  LOOKING TO {adTypeText}
                </h1>
                <p className="share-yourad-map-preview-location mb-20">
                  {capitalizeFirstString(article)} {propertyType}{" "}
                  {shareLocation}
                </p>
              </>
            )}
          </>
        ) : (
          <>
            <h1
              className={`share-yourad-map-preview-title ${
                isSideCard ? "f-size-16" : "f-size-24 "
              }  `}
            >
              {WantCreatedUserId !== loggedInUserId
                ? `LOOKING TO ${adTypeText}`
                : `I'M LOOKING TO ${adTypeText}`}
            </h1>
            <p className="share-yourad-map-preview-location mb-20">
              {capitalizeFirstString(article)} {propertyType} {shareLocation}
            </p>
          </>
        )}
        {prprtyType != "6" && prprtyType != "11" ? (
          <div className="share-yourad-map-preview-specs">
            <div>
              Beds: {noBedRoom} | Baths: {noBathRoom}
            </div>
            <div>Sqft: {sqFt}</div>
            <div>Budget: {bdgt}</div>
            <div className="share-yourad-map-preview-btmLine">
              {showAgentBlock ? (
                agentBlock
              ) : (
                <>
                  <div className="share-yourad-map-preview-btmLine-text">
                    {WantCreatedUserId !== loggedInUserId
                      ? `Find more details listed by this ${
                          !isAgentCreated
                            ? adTypeText === "BUY"
                              ? "buyer"
                              : "renter"
                            : "agent"
                        } on`
                      : "Find more details listed on"}
                  </div>
                  <div
                    className={`share-yourad-map-preview-btmLine-logo ${WantCreatedUserId !== loggedInUserId ? "" : "logo-center"}`}
                  >
                    <Logo type={"logoV2"} />
                  </div>
                </>
              )}
            </div>
          </div>
        ) : (
          <div className="share-yourad-map-preview-specs">
            {prprtyType != "11" && <div>Lot Size: {ltSize}</div>}
            <div>Budget: {bdgt}</div>
            <div className="share-yourad-map-preview-btmLine">
              {showAgentBlock ? (
                agentBlock
              ) : (
                <>
                  <div className="share-yourad-map-preview-btmLine-text">
                    {WantCreatedUserId !== loggedInUserId &&
                      `Find more details listed by this ${clientName ? (adTypeText === "BUY" ? "buyer" : "renter") : "agent"} on`}
                    {WantCreatedUserId == loggedInUserId &&
                      "Find more details listed on"}
                  </div>

                  <div
                    className={`share-yourad-map-preview-btmLine-logo ${WantCreatedUserId !== loggedInUserId ? "" : "logo-center"}`}
                  >
                    <Logo type={"logoV2"} />
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShareCardPreview;
